import * as types from '../mutation-types';
import {authHeader} from '../../helpers';

const state = () => ({
	accessToken: null,
	expiresIn: 0,
	obtainedAt: 0,

	self: {
		username: null,
		permissions: [],
		mainAdmin: false,
	},
});

const actions = {
	login({commit}, {username, password}) {
		return axios.post('/api/auth/login', {
			username,
			password,
		}).then(async response => {
			axios.defaults.headers.common[authHeader] = `Bearer ${response.data.access_token}`;
			
			let permissions = await axios.get('/api/users/self/permissions').then(r => r.data.permissions);

			const auth = {
				accessToken: response.data.access_token,
				expiresIn: response.data.expires_in * 1000,
				obtainedAt: Date.now(),
				username,
				permissions,
				id: response.data.id,
			};

			localStorage.setItem('auth', JSON.stringify(auth));

			commit(types.LOGIN, auth);
		});
	},

	logout({commit}) {
		localStorage.removeItem('auth');
		delete axios.defaults.headers.common[authHeader];
		commit(types.LOGOUT);
	},
};

const mutations = {
	[types.LOGIN](state, payload) {
		state.accessToken = payload.accessToken;
		state.expiresIn = payload.expiresIn;
		state.obtainedAt = payload.obtainedAt ? payload.obtainedAt : Date.now();
		state.self.username = payload.username;
		state.self.permissions = payload.permissions;
		state.self.mainAdmin = payload.permissions.filter(c => c.name == 'full control').length > 0 
								|| payload.username == 'admin';
	},

	[types.LOGOUT](state) {
		state.accessToken = null;
		state.expiresIn = 0;
		state.obtainedAt = 0;
		state.self.username = null;
	},
};

const getters = {
	isAuthenticated: state => state.accessToken ? ((state.obtainedAt + state.expiresIn > Date.now()) ?
		true :
	false) : false,
};

export default {
	namespaced: true,
	state,
	mutations,
	actions,
	getters
};